import { render } from "./LogicDesignerBlock.vue?vue&type=template&id=a2aecb4e&ts=true"
import script from "./LogicDesignerBlock.vue?vue&type=script&lang=ts"
export * from "./LogicDesignerBlock.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\berge\\Desktop\\My Projects\\o2p-shop-planner\\SP.App\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__